import '../styles/InfoList.scss';

import React from 'react';
import { Link } from 'react-router-dom';

type InfoItem = {
    label: string;
    value: React.ReactNode | any;
};

interface InfoListProps {
    title?: string;
    items: InfoItem[];
}

const InfoList: React.FC<InfoListProps> = ({ items, title }) => {
    const renderValue = (value: any) => {
        if (Array.isArray(value)) {
            if (value.every(v => typeof v === 'string' || typeof v === 'number')) {
                return value.join(', ');
            }

            if (value.every(v => typeof v === 'object' && 'id' in v && 'name' in v)) {
                return value.map((v: any, idx: number) => (
                    <React.Fragment key={v.id}>
                        <Link to={`/people/${v.id}`}>{v.name}</Link>
                        {idx < value.length - 1 ? ', ': ''}
                    </React.Fragment>
                ));
            }

            return value.map((v: any) => (v && v.name ? v.name : String(v))).join(', ');
        }

        return value;
    };

    return (
        <div className="info-list">
            {title && <h3 className="info-list-title">{title}</h3>}

            {items.map((item, index) =>
                item.value | item.value?.length ? (
                    <div key={index} className="info-item">
                        <span className="info-title">{item.label.toUpperCase()} </span>
                        <span className="info-value">{renderValue(item.value)}</span>
                    </div>
                ) : null
            )}
        </div>
    );
};

export default InfoList;